import { TextField, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import debounce from "lodash.debounce";
import { useEffect, useMemo, useState } from "react";

function SearchFilter({ value = "", onChange }) {
  const [text, setText] = useState(value);
  const debouncedSearch = useMemo(
    () => debounce((val) => onChange(val), 400),
    [onChange]
  );
  useEffect(() => {
    setText(value);
  }, [value]);

  useEffect(() => {
    return () => debouncedSearch.cancel();
  }, [debouncedSearch]);

  return (
    <TextField
      fullWidth
      value={text}
      placeholder="Phone number, UHID, reference number"
      onChange={(e) => {
        const val = e.target.value;
        setText(val);
        debouncedSearch(val);
      }}
      variant="outlined"
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon sx={{ color: "var(--app-text-muted)" }} />
          </InputAdornment>
        ),
        sx: {
          height: "45px",
          borderRadius: "10px",
          backgroundColor: "var(--app-surface)",
          fontSize: "14px",
          border: "1.2px solid var(--app-border)",
          "& .MuiOutlinedInput-notchedOutline": {
            border: "none",
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            border: "none",
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            border: "none",
          },
        },
      }}
    />
  );
}

export default SearchFilter;
